import { css } from '@emotion/react';
import { margins, paddings } from '@spotnana/blocks/src/utils/styling';
import { themed } from '@spotnana/blocks/src/utils/styling/themed';

export const tripDetailsContainer = themed(
  ({ palette }) => css`
    ${paddings.y.p1}
    ${paddings.x.p1}
    border: none !important;
    ${margins.yb.m2}
    box-shadow: ${palette.shadow.cardShadow};
  `,
);

export const tripSummaryContainer = themed(
  ({ palette }) => css`
    ${margins.yt.m2}
    border-radius: 1rem;
    background-color: ${palette.surface.background};
  `,
);

export const fareContainer = themed(
  ({ palette }) => css`
    ${paddings.y.p2}
    ${paddings.x.p2}
    ${margins.yb.m1}
    border-radius: 0.5rem;
    background-color: ${palette.surface.base};
  `,
);
